import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@src/app/providers/providers';
import { DeviceInfoService } from '@src/app/services/device-info.service';
import { UrlService } from '@src/app/services/url.service';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { Lead } from '../interfaces/lead.interface';

export interface GoogleAuthPayload {
  code: string | undefined;
  callbackUrl: string;
}

@Injectable()
export class VerificationService {
  private http = inject(HttpClient);
  private url = inject(UrlService);
  private deviceInfoService = inject(DeviceInfoService);
  private window = inject(WINDOW);
  private cookieService = inject(CookieService);

  public sendCode(data: { email: string }): Observable<any> {
    return this.http.post(`${this.url.auth}/send-code`, data);
  }

  public checkCode(data: { email: string; code: string }): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(`${this.url.auth}/check-code`, data);
  }

  public checkCodeGoogle(code: string): Observable<{ token: string }> {
    const data: GoogleAuthPayload = {
      code,
      callbackUrl: this.window.origin + '/auth/google-callback',
    };
    return this.http.post<{ token: string }>(`${this.url.auth}/check-google-code`, data);
  }

  public getAuthGoogle(): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.url.auth}/google-redirect`, {
      callbackUrl: this.window.origin + '/auth/google-callback',
    });
  }

  public verification(token: string): Observable<any> {
    const body = {
      token: token,
      geo: this.deviceInfoService.geo(),
      deviceInfo: this.deviceInfoService.deviceInfoData(),
      phone: this.cookieService.get('phone'),
    };
    return this.http.post<any>(`${this.url.auth}/login`, body);
  }

  public authenticateManually(data: Lead): Observable<void> {
    const body = {
      geo: this.deviceInfoService.geo(),
      deviceInfo: this.deviceInfoService.deviceInfoData(),
      ...data,
    };
    return this.http.post<void>(`${this.url.auth}/login-manual`, body);
  }
}
